module.exports = __webpack_public_path__ + "img/helper_phone@3x.47375eed.png";